module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-list-container"
  }, [_c('data-table', {
    attrs: {
      "data-set": _vm.orders,
      "page-length": 50,
      "columns": [{
          name: 'Order',
          prop: 'id',
          type: 'number'
        },
        {
          name: 'Customer',
          prop: ['first_name', 'last_name', 'email'],
          type: 'text'
        },
        {
          name: 'Account',
          prop: 'account_number',
          type: 'number'
        },
        {
          name: 'Transaction',
          prop: ['payment_method', 'discount_code'],
          type: 'text'
        },
        {
          name: 'Total',
          prop: 'total',
          type: 'number'
        },
        {
          name: 'Items',
          prop: 'items',
          display: false,
          nested: true,
          subprop: 'product_sku',
          type: 'string'
        },
        {
          name: 'Submitted',
          prop: 'created_at',
          type: 'date',
          searchable: false,
          filter: ['moment', ['from', 'now']]
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_Order",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'order',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("\n        #" + _vm._s(props.row.id) + "\n        "), _c('br'), _vm._v("\n        View Order\n      ")])]
      }
    }, {
      key: "column_Customer",
      fn: function(props) {
        return [(props.row.user_id) ? _c('router-link', {
          attrs: {
            "to": {
              name: 'user',
              params: {
                id: props.row.user_id
              }
            }
          }
        }, [_vm._v("\n        " + _vm._s(props.row.first_name) + " " + _vm._s(props.row.last_name) + "\n        "), (props.row.user_id) ? _c('i', {
          staticClass: "fa fa-user"
        }) : _vm._e()]) : _c('span', [_vm._v("\n        " + _vm._s(props.row.first_name) + " " + _vm._s(props.row.last_name) + "\n      ")]), _vm._v(" "), _c('br'), _vm._v("\n      " + _vm._s(props.row.line1) + "\n      "), _c('br'), _vm._v("\n      Zip: "), _c('strong', [_vm._v(_vm._s(props.row.zip))])]
      }
    }, {
      key: "column_Account",
      fn: function(props) {
        return [(_vm.acct.order_id !== props.row.id) ? _c('div', {
          staticClass: "edit-account-number",
          staticStyle: {
            "min-width": "110px"
          },
          on: {
            "click": function($event) {
              return _vm.editAcctNum(props.row)
            }
          }
        }, [(props.row.account_number) ? _c('div', [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v("   " + _vm._s(props.row.account_number))]) : _c('div', [_c('i', {
          staticClass: "fa fa-edit"
        }), _vm._v("   "), _c('em', [_vm._v("- none -")])])]) : _vm._e(), _vm._v(" "), (_vm.acct_edit && _vm.acct.order_id === props.row.id) ? _c('div', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.acct.current_acct_num),
            expression: "acct.current_acct_num"
          }],
          staticClass: "input",
          staticStyle: {
            "max-width": "90px"
          },
          attrs: {
            "type": "text",
            "name": "acct_edit",
            "maxlength": "8"
          },
          domProps: {
            "value": (_vm.acct.current_acct_num)
          },
          on: {
            "input": function($event) {
              if ($event.target.composing) { return; }
              _vm.$set(_vm.acct, "current_acct_num", $event.target.value)
            }
          }
        }), _vm._v(" "), _c('div', [_c('button', {
          staticClass: "button is-small",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.cancelAcctEdit()
            }
          }
        }, [_vm._v("CANCEL")]), _vm._v(" "), (_vm.acct.current_acct_num !== _vm.acct.start_acct_num) ? _c('button', {
          staticClass: "button is-small is-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function($event) {
              return _vm.updateAccountNumber()
            }
          }
        }, [_vm._v("SAVE")]) : _vm._e()])]) : _vm._e()]
      }
    }, {
      key: "column_Transaction",
      fn: function(props) {
        return [_vm._v("\n      " + _vm._s(props.row.payment_method) + "\n      "), (props.row.discount_code !== null) ? _c('span', [_c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(props.row.discount_code))]), _vm._v(" Discount\n      ")]) : _vm._e(), _vm._v(" "), _c('hr', {
          staticClass: "table-hr"
        }), _vm._v("\n      " + _vm._s(_vm.reduceOrderItems(props.row.items)) + "\n    ")]
      }
    }, {
      key: "column_Total",
      fn: function(props) {
        return [_c('div', {
          staticClass: "has-text-right"
        }, [_vm._v("\n        " + _vm._s(_vm._f("currency")((props.row.discounted_total !== null ? props.row.discounted_total : props.row.total))) + "\n      ")])]
      }
    }, {
      key: "controls",
      fn: function(props) {
        return [_c('td', [_c('div', {
          staticClass: "level is-mobile"
        }, [_c('div', {
          staticClass: "level-left"
        }, [_c('div', {
          staticClass: "level-item"
        }, [_c('span', {
          staticClass: "clickable icon",
          attrs: {
            "title": props.row.printed ? 'Reprint Order' : 'Print Order'
          },
          on: {
            "click": function($event) {
              return _vm.printOrder(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-print"
        })])]), _vm._v(" "), (props.row.printed === true && _vm.isSuperUser) ? _c('div', {
          staticClass: "level-item"
        }, [(props.row.archived === true) ? _c('span', {
          staticClass: "clickable fa-stack",
          attrs: {
            "title": "Unarchive Order"
          },
          on: {
            "click": function($event) {
              return _vm.unarchiveOrder(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-archive fa-stack-1x"
        }), _vm._v(" "), _c('i', {
          staticClass: "fa fa-ban fa-stack-2x text-danger"
        })]) : _c('span', {
          staticClass: "clickable icon",
          attrs: {
            "title": "Archive Order"
          },
          on: {
            "click": function($event) {
              return _vm.archiveOrder(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-archive"
        })])]) : _vm._e(), _vm._v(" "), (_vm.isSuperUser) ? _c('div', {
          staticClass: "level-item"
        }, [(props.row.voided !== true) ? _c('span', {
          staticClass: "clickable icon",
          attrs: {
            "title": "Void Order"
          },
          on: {
            "click": function($event) {
              return _vm.voidOrder(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-ban text-danger"
        })]) : _c('span', {
          staticClass: "clickable icon",
          attrs: {
            "title": "Reinstate Order"
          },
          on: {
            "click": function($event) {
              return _vm.unvoidOrder(props.row)
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-undo text-danger"
        })])]) : _vm._e()])])])]
      }
    }])
  }), _vm._v(" "), (_vm.voidingOrder !== null) ? _c('div', {
    staticClass: "void-order-reason-container"
  }, [_c('div', {
    staticClass: "void-order-reason-dialog"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("Voiding Order #" + _vm._s(_vm.voidingOrder))]), _vm._v(" "), _c('form-group', {
    attrs: {
      "type": "text",
      "label": "Why are you voiding this order?",
      "id": "void_reason",
      "placeholder": "Don't like this customer",
      "error": _vm.voidForm.errors.get('voidReason')
    },
    on: {
      "event": function($event) {
        return _vm.voidForm.listen(_vm.voidForm, $event)
      }
    },
    model: {
      value: (_vm.voidForm.voidReason),
      callback: function($$v) {
        _vm.$set(_vm.voidForm, "voidReason", $$v)
      },
      expression: "voidForm.voidReason"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "button is-dark",
    on: {
      "click": function($event) {
        _vm.voidingOrder = null
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "is-pulled-right button is-primary",
    on: {
      "click": function($event) {
        return _vm.voidOrder()
      }
    }
  }, [_vm._v("Okay, void it.")])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5b303235"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/components/OrderList.vue
// module id = 540
// module chunks = 0